import service1 from '../assets/services/service-1.svg';
import service2 from '../assets/services/service-2.svg';
import service3 from '../assets/services/service-3.svg';
import service4 from '../assets/services/service-4.svg';
import service5 from '../assets/services/service-5.svg';
import service6 from '../assets/services/service-6.svg';

export const SERVICES = [service1, service2, service3, service4, service5, service6];